// Срок запроса — общий для клиента Mini App (src/api/client.ts) и его подмены магазинной сборки
// (src/store/overrides/client.ts): одна реализация, одинаковое поведение в обеих сборках.

/**
 * Тайм-аут запроса (HQ-1323, HQ-1525): без ответа за 15 с (плохая мобильная сеть) клиент отдаёт ApiError('network', 0),
 * как при обрыве, и экран показывает ошибку с «Повторить» вместо вечного скелетона. Срок покрывает и чтение тела ответа.
 */
export const REQUEST_TIMEOUT_MS = 15_000;

/** Свой signal запроса: внешний signal вызывающего + тайм-аут. Отмена вызывающим остаётся отменой, не тайм-аутом. */
export function deadline(outer?: AbortSignal) {
  const controller = new AbortController();
  let timedOut = false;
  const onAbort = () => controller.abort(outer?.reason);
  if (outer?.aborted) onAbort(); else outer?.addEventListener('abort', onAbort, { once: true });
  const timer = setTimeout(() => {
    timedOut = true;
    controller.abort(new DOMException('Request timed out', 'TimeoutError'));
  }, REQUEST_TIMEOUT_MS);
  return {
    signal: controller.signal,
    timedOut: () => timedOut,
    dispose() { clearTimeout(timer); outer?.removeEventListener('abort', onAbort); },
  };
}
